import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {PropType} from "vue";
import {AppConfigComponent, AppConfigComponentType} from "@/model/AppConfig";
import AppConfigComponentDrawerAdComponent from "./AppConfigComponentDrawerAdComponent.vue";
import AppConfigComponentDrawerNavGroupComponent from "./AppConfigComponentDrawerNavGroupComponent.vue";
import AppConfigComponentDrawerListComponent from "./AppConfigComponentDrawerListComponent.vue";
import AppConfigComponentDrawerListGroupComponent from "./AppConfigComponentDrawerListGroupComponent.vue";
import AppConfigComponentDrawerNews from "@/views/appconfig/drawer/AppConfigComponentDrawerNews.vue";


const __default__ = {
  name: "AppConfigComponentDrawerComponent",

}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  component: {
    type: Object as PropType<AppConfigComponent>,
    required: true
  },

  // 是否是最后一个组件
  isLastComponent: {
    type: Boolean,
    required: false,
    default: false
  }
},
  setup(__props) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.component.type === _unref(AppConfigComponentType).AD)
      ? (_openBlock(), _createBlock(AppConfigComponentDrawerAdComponent, {
          key: 0,
          component: __props.component
        }, null, 8, ["component"]))
      : _createCommentVNode("", true),
    (__props.component.type === _unref(AppConfigComponentType).NAVIGATION_GROUP)
      ? (_openBlock(), _createBlock(AppConfigComponentDrawerNavGroupComponent, {
          key: 1,
          component: __props.component
        }, null, 8, ["component"]))
      : _createCommentVNode("", true),
    (__props.component.type === _unref(AppConfigComponentType).LIST)
      ? (_openBlock(), _createBlock(AppConfigComponentDrawerListComponent, {
          key: 2,
          "is-last-component": __props.isLastComponent,
          component: __props.component
        }, null, 8, ["is-last-component", "component"]))
      : _createCommentVNode("", true),
    (__props.component.type === _unref(AppConfigComponentType).LIST_GROUP)
      ? (_openBlock(), _createBlock(AppConfigComponentDrawerListGroupComponent, {
          key: 3,
          "is-last-component": __props.isLastComponent,
          component: __props.component
        }, null, 8, ["is-last-component", "component"]))
      : _createCommentVNode("", true),
    (__props.component.type === _unref(AppConfigComponentType).NEWS)
      ? (_openBlock(), _createBlock(AppConfigComponentDrawerNews, {
          key: 4,
          component: __props.component
        }, null, 8, ["component"]))
      : _createCommentVNode("", true)
  ]))
}
}

})